import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEY } from 'app/business-logic/services/query-key';
import { deleteNoiseEventClassification } from 'app/business-logic/services/noise-service/deleteNoiseEventClassification';
import { useI18n } from 'core/hooks/useI18n';
import { useNavigateToNoiseClassificationListing as useBackToListing } from '../noise-classifications-listing/useNavigateToNoiseClassificationListing';

export const useDeleteNoiseClassification = () => {
  const { l10n } = useI18n('app/views/configuration/pages/noise', 'classifications.error');
  const backToListing = useBackToListing();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: deleteNoiseEventClassification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY.noiseEventClassifications],
      });
      backToListing();
    },
    onError: (error, id) => {
      // update error handling in a more reliable way when backend provides it
      if (error.message.includes('The classification is currently applied to one or more noise events.')) {
        alert(l10n('classificationIsApplied', { id }));
      } else if (window.confirm(l10n('tryAgain'))) {
        mutate(id);
      }
    },
  });
  return {
    deleteNoiseClassification: mutate,
    isPending,
  };
};
